export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';

export const downloadFileSuccess = file => ({
    type: DOWNLOAD_FILE_SUCCESS,
    payload: { file },
});
